import React, { FC, SVGProps } from 'react';

export const Holistic: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="80" height="80" rx="40" fill="#B1CB8F" />
    <path
      d="M40 42V27"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 37L33 45"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0938 37.1875C23.8024 37.1875 25.1875 35.8024 25.1875 34.0938C25.1875 32.3851 23.8024 31 22.0938 31C20.3851 31 19 32.3851 19 34.0938C19 35.8024 20.3851 37.1875 22.0938 37.1875Z"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M55 37L47 45"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.9062 37.1875C56.1976 37.1875 54.8125 35.8024 54.8125 34.0938C54.8125 32.3851 56.1976 31 57.9062 31C59.6149 31 61 32.3851 61 34.0938C61 35.8024 59.6149 37.1875 57.9062 37.1875Z"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.0938 26.1875C41.8024 26.1875 43.1875 24.8024 43.1875 23.0938C43.1875 21.3851 41.8024 20 40.0938 20C38.3851 20 37 21.3851 37 23.0938C37 24.8024 38.3851 26.1875 40.0938 26.1875Z"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48 50C48 54.4183 44.4183 58 40 58C35.5817 58 32 54.4183 32 50C32 45.5817 35.5817 42 40 42C44.4183 42 48 45.5817 48 50Z"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
    />
  </svg>
);
